module.exports = SharedDependencies.React['task-hub'];